// @ts-ignore
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../../imageLarge.fragment.generated';
import { QuestionnaireConditionFragmentDoc } from '../../condition/QuestionnaireCondition.fragment.generated';
export const QuestionnaireQuestionChoiceOptionContentImageCardConditionalFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOptionContentImageCardConditional on QuestionnaireQuestionChoiceOptionContentImageCardConditional {
  image {
    ...imageLarge
  }
  title
  description
  conditions {
    ...questionnaireCondition
  }
}
    ${ImageLargeFragmentDoc}
${QuestionnaireConditionFragmentDoc}`;